// EstimateBudgetItemBase Component

/* eslint indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import ReactDOM from 'react-dom'
import ReactSelect from 'react-select'

import app from '../../../app.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Util from '../../../lib/util.jsx'
import Input from '../../../common/form/input/input.jsx'
import FormRateCardAutoComplete from '../../../common/form/ratecard_auto_complete/ratecard_auto_complete.jsx'
import DateRangePicker from '../../../common/form/daterange_picker/daterange_picker.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import PopupDescription from '../../popup/popup_description/popup_description.jsx'
import PopupBudgetPurchaseorder from '../../popup/popup_budget_purchaseorder/popup_budget_purchaseorder.jsx'
import MenuDropdown from '../../../common/common/menu_dropdown/menu_dropdown.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import currency from '../../../lib/currency.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import InputNumber from '../../../common/form/input_number/input_number.jsx'
import Button from '../../../common/common/button/button.jsx'
import FormVatAutoComplete from '../../../common/form/vat_autocomplete/vat_autocomplete.jsx'
import FormVatTypeSelect from '../../../common/form/vat_typeselect/vat_typeselect.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import { PHASE_TYPES } from '../../../../shared/constants'
import { trackAddPurchaseOrder } from '../project_budget_item/utils.js'

class EstimateBudgetItemBase extends Component {
  constructor (props) {
    super(props)

    this.data = {
      activityKeyword: props.item && props.item.title ? props.item.title : '',
      menuItems: [
        {
          icon: 'common-menudelete',
          title: 'project.viewBudget.deleteActivity',
          action: 'delete'
        }
      ],
      selectedRateCard: null,
      vatLevels: props.vatLevels || [],
      vatKeyword: ''
    }

    this._references = {
      inputTimeTitle: React.createRef(),
      inputNormalTitle: React.createRef(),
      confirmDelete: React.createRef(),
      triggerDescription: React.createRef(),
      daterange: React.createRef(),
      triggerSetting: React.createRef(),
      description: React.createRef(),
      settingsMenu: React.createRef(),
      triggerPurchaseOrder: React.createRef(),
      refBudgetPurchaseOrder: React.createRef()
    }

    this.state = {
      activityTitleErr: false
    }

    this._canCreateNewText = true
    this._summaryTime = null
    this._documentListener = this._handleDocumentClick.bind(this)
  }

  static propTypes = {
    item: PropTypes.object,
    rateCards: PropTypes.array,
    onCreateItemSupplier: PropTypes.object,
    estimateRateCards: PropTypes.array,
    onDeleteItemSupplier: PropTypes.object,
    onItemCreate: PropTypes.func,
    onItemUpdate: PropTypes.func,
    onUpdateSubtotal: PropTypes.func,
    onUpdateTotal: PropTypes.func,
    onUpdateEditable: PropTypes.func,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onRemove: PropTypes.func,
    connectDragSource: PropTypes.func,
    onSearchSupplier: PropTypes.func,
    dragItem: PropTypes.func,
    isEstimate: PropTypes.bool,
    disabledEdit: PropTypes.bool,
    hideDateRange: PropTypes.bool,
    phaseStatus: PropTypes.string,
    rateMarkup: PropTypes.number,
    onCreatePurchaseOrder: PropTypes.func,
    onViewPurchaseOrder: PropTypes.func,
    onCreateContact: PropTypes.func,
    calculateSpentAmount: PropTypes.func,
    disableDrag: PropTypes.bool,
    onInsertItemInMiddle: PropTypes.func,
    filterType: PropTypes.string,
    isDragLayer: PropTypes.bool,
    showDefaultVat: PropTypes.bool,
    vatLevels: PropTypes.array,
    showActivity: PropTypes.bool,
    showRate: PropTypes.bool,
    showTax: PropTypes.bool,
    phaseFromDate: PropTypes.string,
    phaseToDate: PropTypes.string,
    projectStartDate: PropTypes.string,
    projectEndDate: PropTypes.string,
    calculateMarkupPercentage: PropTypes.func,
    calculateSellingPrice: PropTypes.func,
    taxRateVatOptions: PropTypes.array,
    showVatAutocomplete: PropTypes.bool,
    showLabelType: PropTypes.bool,
    onCreateTaxRate: PropTypes.func,
    hidePagebreak: PropTypes.bool,
    isQuickbookConnected: PropTypes.bool,
    quickbookItems: PropTypes.array,
    reloadQuickbookItems: PropTypes.func,
    budget: PropTypes.object
  }

  componentDidMount () {
    const { isEstimate, item } = this.props
    if (item && item.editable && item.editable === 'title') {
      if (isEstimate && this._references.inputNormalTitle.current) {
        this._references.inputNormalTitle.current.focus()
      } else if (this._references.inputTimeTitle.current) {
        this._references.inputTimeTitle.current.focus()
      }
    }
  }

  componentWillUnmount () {
    // unregister click handler
    this._onHideAddAction()
  }

  render () {
    const {
      isEstimate,
      item,
      dragItem,
      isDragLayer,
      showRate,
      showTax,
      showLabelType,
      isDiscountPhase
    } = this.props
    const connectDragSource =
      this.props.connectDragSource || this._connectDragSource

    if (!item) {
      return null
    }

    let className = ''
    if (showRate) {
      className = 'showrate'
    } else if (showTax) {
      className = 'showtax'
    } else {
      className = 'showactivity'
    }

    const bHasSubCont =
      item.type === 'time-activity' || item.type === 'expense-activity'

    if (isEstimate) {
      if (item.type === 'pagebreak') {
        return this._renderPageBreaker()
      } else {
        return (
          <div
            className={classnames('estimatebudgetitem', {
              projectbudgetitem_isdragging:
                !isDragLayer &&
                dragItem &&
                dragItem.dragItemType === 'item' &&
                dragItem.dragId === item.dragId,
              projectbudgetitem_isdraftdrag:
                !isDragLayer && item.isEmptyDragItem,
              dropopen: this.data.showExpand,
              showadd: item.showAdd,
              hasnotitle: !item.bTitleCompleted
            })}
          >
            <span className='itemcontentbg' />
            {this._isEditEnabled() && !isDiscountPhase &&
              connectDragSource(
                <div className='hovericon'>
                  <span className='iconcont'>
                    <i className='icon icon-budget-listmenu' />
                  </span>
                </div>
              )}
            {item.type === 'text' ? this._renderEstimateActivityText()
              : isDiscountPhase
              ? this._renderDiscountColumns()
              : item.type === 'time-activity' || item.type === 'expense-activity'
              ? this._renderEstimateActivityTime()
              : null}

            {!this.data.showExpand && bHasSubCont && (
              <span
                className='itemaccordion'
                onClick={this._onToggleExpand.bind(this)}
              >
                <i className='icon icon-grid-expand normal' />
              </span>
            )}
            {this.data.showExpand && (
              <span
                className='itemaccordion'
                onClick={this._onToggleExpand.bind(this)}
              >
                <i className='icon icon-planner-accordionclose' />
              </span>
            )}
            {bHasSubCont && (
              <div className='itemsubcont'>
                <div className={`desccont ${className}`}>
                  <div className='dropcol coltitle typo typo_viewsummary'>
                    {item.editable === 'description' ? (
                      <div className='label'>
                        <WysiwygEditor
                          placeholder='project.viewBudget.enterDescription'
                          value={item.description}
                          onBlur={this._onBlurActivityInput.bind(
                            this,
                            'description'
                          )}
                          onChange={this._onChangeActivityDesc.bind(
                            this,
                            'description'
                          )}
                          onKeyDown={this._onKeyPressSummary.bind(
                            this,
                            'description'
                          )}
                          autoFocus
                        />
                      </div>
                    ) : (
                      <div
                        className='label'
                        onClick={this._onEditActivity.bind(this, 'description')}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              item.description ||
                              IntlUtil.convertMessage(
                                'project.viewBudget.addDescription'
                              )
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {showLabelType && (
                  <div className='infocont'>
                    <div className='dropcol coltitle'>
                      <div
                        className='label infocol'
                        onClick={this._onEditActivity.bind(this, 'labelType')}
                      >
                        <div className='info infoservice'>
                          <IntlMessage ident='project.viewBudget.labelInitialLabelType' />
                        </div>
                        &nbsp;
                        <div className='value infoservice'>
                          <FormVatTypeSelect
                            name='labelType'
                            value={item.labelType}
                            disabled={this.props.disabledEdit}
                            isQuickbookConnected={
                              this.props.isQuickbookConnected
                            }
                            quickbookItems={this.props.quickbookItems}
                            onChange={this._onChangeActivityLabelType.bind(
                              this,
                              'labelType'
                            )}
                            onBlur={this._onBlurActivityInput.bind(
                              this,
                              'labelType'
                            )}
                            onInputKeyDown={this._onKeyPressActivityVatInput.bind(
                              this,
                              'labelType'
                            )}
                            reloadQuickbookItems={
                              this.props.reloadQuickbookItems
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className={`splitterwrap ${className}`}>
                  <div className='splitteritem col1' />
                  <div className='splitteritem col2' />
                  <div className='splitteritem col3' />
                </div>
              </div>
            )}

            {!item.showAdd && this._isEditEnabled() && (
              <div className='addsplitter'>
                <div
                  className='hovericon addaction'
                  onClick={this._onShowAddAction.bind(this, item)}
                >
                  <span className='iconcont'>
                    <i className='icon icon-common-itemadd' />
                  </span>
                </div>
                <div className='line' />
              </div>
            )}
            {item.showAdd && this._renderActivityAction()}
          </div>
        )
      }
    } else {
      const itemwrapClass = classnames('phaseitemcontainer', {
        isdragging:
          dragItem &&
          dragItem.dragItemType === 'item' &&
          dragItem.dragId === item.dragId
      })
      if (item.type === 'text') {
        return (
          <div className={itemwrapClass}>
            {!item.showAdd && this._isEditEnabled() && (
              <div className='addsplitter'>
                <div
                  className='hovericon addaction'
                  onClick={this._onShowAddAction.bind(this, item)}
                >
                  <span className='iconcont'>
                    <i className='icon icon-common-itemadd' />
                  </span>
                </div>
                <div className='line' />
              </div>
            )}
            {this._renderActivityText()}
            {item.showAdd && this._renderActivityAction()}
          </div>
        )
      } else if (item.type === 'time-activity') {
        return (
          <div className={itemwrapClass}>
            {!item.showAdd && this._isEditEnabled() && (
              <div className='addsplitter'>
                <div
                  className='hovericon addaction'
                  onClick={this._onShowAddAction.bind(this, item)}
                >
                  <span className='iconcont'>
                    <i className='icon icon-common-itemadd' />
                  </span>
                </div>
                <div className='line' />
              </div>
            )}
            {this._renderActivityTime()}
            {item.showAdd && this._renderActivityAction()}
          </div>
        )
      } else if (item.type === 'expense-activity') {
        return (
          <div className={itemwrapClass}>
            {!item.showAdd && this._isEditEnabled() && (
              <div className='addsplitter'>
                <div
                  className='hovericon addaction'
                  onClick={this._onShowAddAction.bind(this, item)}
                >
                  <span className='iconcont'>
                    <i className='icon icon-common-itemadd' />
                  </span>
                </div>
                <div className='line' />
              </div>
            )}
            {this._renderActivityExpense()}
            {item.showAdd && this._renderActivityAction()}
          </div>
        )
      }
    }

    return <div />
  }

  _onChangeActivityLabelType (name, object) {
    const value = object.value
    const item = this.props.item
    item[name] = value
    item.bSaveItem = true

    if (name === 'labelType' && this.props.onItemUpdate) {
      item.labelType = value
      this.props.onItemUpdate(item, name)
    }

    this._onChange()
  }

  _renderActivityAction () {
    const hidePagebreak = this.props.hidePagebreak

    return (
      <div className='phaseactions'>
        <span
          className='phaseitem-close'
          onClick={this._onHideAddAction.bind(this)}
        >
          <i className='icon icon-phase-close' />
        </span>
        <div className='action'>
          <Button
            className='button_phase'
            title='project.viewBudget.addActivity'
            onClick={this._onInsertItemInMiddle.bind(this, 'time-activity')}
          />
          <Button
            className='button_phase'
            title='project.viewBudget.text'
            onClick={this._onInsertItemInMiddle.bind(this, 'text')}
          />
          {!hidePagebreak && (
            <Button
              className='button_phase'
              title='project.viewBudget.pageBreaker'
              onClick={this._onInsertItemInMiddle.bind(this, 'pagebreak')}
            />
          )}
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onInsertItemInMiddle (type, ev) {
    ev.preventDefault()

    if (this.props.onInsertItemInMiddle) {
      this.props.onInsertItemInMiddle(type, ev)
    }
  }

  _onHideAddAction () {
    document.removeEventListener('click', this._documentListener, false)

    if (this.props.item) {
      this.props.item.showAdd = false
    }

    this.setState({ dataDate: new Date() })
  }

  _onChangingType (type, ev) {
    ev.preventDefault()

    const item = this.props.item

    if (type === 'subtotal') {
      item.type = type
      item.editable = false
      item.bTitleCompleted = true
    } else {
      item.type = type
      item.editable = 'title'
      item.bTitleCompleted = false
    }

    this._onChange()
  }

  _onBlurActivityText (_value) {
    const item = this.props.item
    item.editable = false

    if (!item.id && this.props.onItemCreate) {
      this.props.onItemCreate(item)
    } else {
      this.props.onItemUpdate(item, 'title')
    }
  }

  _onChangeActivityText (value) {
    this.props.item.title = value
  }

  _onChangeActivityDesc (name, value) {
    const item = this.props.item
    item[name] = value
    item.bSaveItem = true
    this.setState({ dataDate: new Date() })

    if (this.props.onItemUpdate) {
      this.props.onItemUpdate(item, 'description')
    }
  }

  _onClickSetting (idx, e) {
    e.preventDefault()

    if (this._references.settingsMenu.current) {
      this._references.settingsMenu.current.show()
    }
    this.forceUpdate()
  }

  _onChangeActivityInput (name, value) {
    const item = this.props.item
    item[name] = value

    item.bUpdateSpentAmount = false
    item.bUpdateTotal = false
    item.bSaveItem = true

    if (['noHours', 'pricePerHour', 'discountPercentage'].includes(name)) {
      item.bUseTotal = false
    } else if (name === 'total') {
      item.bUseTotal = true
      item.noHours = 0
      item.pricePerHour = 0
    }

    if (name === 'vat' && this.props.onItemUpdate) {
      item.vat = parseInt(value, 10)
      this.props.onItemUpdate(item, name)
    }

    if (
      _.findIndex(
        [
          'sellingPrice',
          'noHours',
          'pricePerHour',
          'total',
          'vat',
          'markupPercentage',
          'discountPercentage'
        ],
        itmName => itmName === name
      ) >= 0
    ) {
      item.bUpdateSpentAmount = true
      item.bUpdateTotal = true
    }

    this._onChange()
  }

  _onChangeActivityVatKeyword (item, value) {
    this.data.vatKeyword = value
    this.data.showVatAdd = false

    let vatIndex = 0
    if (item.labelType !== '') {
      vatIndex = _.findIndex(this.props.taxRateVatOptions, opt => {
        const vatValue = parseFloat(this.data.vatKeyword) || ''
        return opt.value === vatValue
      })
    }

    if (this.data.vatKeyword && vatIndex < 0) {
      this.data.showVatAdd = true
    }

    this.setState({ dataDate: new Date() })
  }

  _onChangeActivityVat (name, object) {
    const value = object.value
    const item = this.props.item
    item[name] = value
    item.bSaveItem = true
    item.editable = false

    if (name === 'vat' && this.props.onItemUpdate) {
      item.vat = parseFloat(value)
      this.props.onItemUpdate(item, name)
    }

    this._onChange()
  }

  _onSelectActivityVat (vatObj) {
    this.data.showVatAdd = false
    this._onChangeActivityVat('vat', vatObj)
  }

  _onSaveVat (vatObj) {
    const item = this.props.item

    this.data.showVatAdd = false

    this._onChangeActivityVat('vat', vatObj)

    if (this.props.onCreateTaxRate) {
      this.props.onCreateTaxRate({
        title: vatObj.label,
        isService: item.labelType === 'Service',
        isProduct: item.labelType === 'Product',
        percentage: parseFloat(vatObj.value)
      })
    }
  }

  _onBlurVat () {
    this.data.showVatAdd = false
    this.props.item.editable = false

    this.setState({ dataDate: new Date() })
  }

  _onKeyPressVat (ev) {
    this.data.vatKeyword = ''

    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      if (
        this._handleActivityInputChanged('vat', false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _updateActivityTotal (name, _value) {
    const item = this.props.item
    const possibleTypes = ['time-activity', 'expense-activity']
    const possibleColumns = [
      'sellingPrice',
      'noHours',
      'pricePerHour',
      'total',
      'markupPercentage',
      'discountPercentage'
    ]

    if (!possibleTypes.includes(item.type) || !possibleColumns.includes(name)) {
      return
    }

    if (name === 'discountPercentage') {
      const totalAmount = (this.props.budget?.phases || [])
        .filter(phase => phase.type !== PHASE_TYPES.DISCOUNT)
        .reduce((prevValue, currValue) => prevValue + currValue.total, 0)

      item.total = totalAmount * (item.discountPercentage / 100) || 0

      return
    }

    // If total already set, no need calculate it
    if (!item.total || name !== 'total') {
        if (
          item.noHours === undefined ||
          item.noHours === '' ||
          isNaN(parseFloat(item.noHours))
        ) {
          item.noHours = 0
        }

        if (
          item.pricePerHour === undefined ||
          item.pricePerHour === '' ||
          isNaN(parseFloat(item.noHours))
        ) {
          item.pricePerHour = 0
        }

      item.noHours = parseFloat(item.noHours)
      item.pricePerHour = parseFloat(item.pricePerHour)

      if (
        item.type === 'time-activity' ||
        (item.type === 'expense-activity' && !item.bUseTotal)
      ) {
        item.total = item.noHours * item.pricePerHour
        item.total = parseFloat(item.total.toFixed(2))
      }
    }

    if (item.type === 'expense-activity') {
      let bUpdateSellingPrice = false
      if (name === 'total') {
        if (item.total === undefined || item.total === '') {
          item.total = 0
        }

        bUpdateSellingPrice = true
      } else if (name === 'sellingPrice') {
        if (item.sellingPrice === undefined || item.sellingPrice === '') {
          item.sellingPrice = 0
        }

        if (this.props.calculateMarkupPercentage) {
          item.markupPercentage = this.props.calculateMarkupPercentage(
            item.total,
            item.sellingPrice
          )
        }
      } else if (name === 'markupPercentage') {
        if (
          item.markupPercentage === undefined ||
          item.markupPercentage === ''
        ) {
          item.markupPercentage = 0
        }

        bUpdateSellingPrice = true
      } else if (name === 'noHours') {
        if (item.noHours === undefined || item.noHours === '') {
          item.noHours = 0
        }

        bUpdateSellingPrice = true
      } else if (name === 'pricePerHour') {
        if (item.pricePerHour === undefined || item.pricePerHour === '') {
          item.pricePerHour = 0
        }

        bUpdateSellingPrice = true
      }

      if (this.props.calculateSellingPrice && bUpdateSellingPrice) {
        item.sellingPrice = this.props.calculateSellingPrice(
          item.total,
          item.markupPercentage
        )
      }
    } else if (item.type === 'time-activity' && name === 'pricePerHour') {
      item.spentAmount = item.timeSpent
        ? item.pricePerHour * (item.timeSpent / 60)
        : 0
      item.spentAmount = parseFloat(item.spentAmount.toFixed(2))
    }
  }

  _handleSearchActivity (keyword) {
    let titleErr = this.state.activityTitleErr
    if (titleErr && keyword !== '') {
      titleErr = false
    }

    this.props.item.title = keyword
    this.props.item.bSaveItem = true

    this.data.activityKeyword = keyword
    this.setState({ activityTitleErr: titleErr, dataDate: new Date() })
  }

  _handleActivityTitleSelect (obj) {
    let rateCards = this.props.rateCards
    if (this.props.isEstimate) {
      rateCards = this.props.estimateRateCards
    }

    const rate = _.find(rateCards, rateCard => {
      return (
        rateCard.value === obj.value &&
        rateCard.amount !== 'undefined' &&
        rateCard.amount !== null
      )
    })

    this.data.selectedRateCard = rate

    const item = this.props.item
    item.title = obj.value
    item.bTitleCompleted = true
    item.noHours = 0
    item.pricePerHour = rate.amount
    item.total = item.noHours * item.pricePerHour
    item.editable = 'noHours'
    item.bSaveItem = true
    // In scope of ROD-755 when expense is selected we overwrite the default markupPercentage
    if (obj.markupPercentage === 0 || obj.markupPercentage) {
      item.markupPercentage = obj.markupPercentage
    }

    this.data.activityKeyword = ''
    this._updateActivityTotal('total', item.total)

    if (!item.id && this.props.onItemCreate) {
      this.props.onItemCreate(item)
      this.props.onUpdateTotal()
    } else {
      this.props.calculateSpentAmount(item, () => {
        this.props.onItemUpdate(item, [
          'title',
          'noHours',
          'pricePerHour',
          'total',
          'spentAmount',
          'percentage',
          'sellingPrice',
          'discountPercentage'
        ])
        this.props.onUpdateTotal()
      })
    }

    this.setState({ dataDate: new Date() })
  }

  _handleActivityTitleBlur (ev, bShowOptions) {
    const item = this.props.item
    if (!item.title) {
      this.setState({ activityTitleErr: true })
      return false
    }

    if (bShowOptions) {
      if (item.title) {
        if (!item.id && this.props.onItemCreate) {
          this.props.onItemCreate(item)
          item.editable = 'title'
        } else {
          this._onSave()
        }
      }
    } else if (!this._handleActivityInputChanged('title', true, false, ev)) {
      ev.preventDefault()
      ev.stopPropagation()

      this.data.activityKeyword = ''
    }

    return true
  }

  _onKeyPressActivityTitleInput (ev) {
    const item = this.props.item
    if (!item.title) {
      this.setState({ activityTitleErr: true })
      return false
    }

    this.data.activityKeyword = ''

    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      if (
        this._handleActivityInputChanged('title', false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _onBlurActivityInput (name, ev) {
    if (this._references.daterange.current) {
      this._references.daterange.current.hide()
    }

    this._updateActivityTotal(name, this.props.item.total)

    if (!this._handleActivityInputChanged(name, true, false, ev)) {
      ev.preventDefault()
      ev.stopPropagation()
    }

    return true
  }

  _onKeyPressActivityInput (name, ev) {
    if (this._references.daterange.current) {
      this._references.daterange.current.hide()
    }

    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      this._updateActivityTotal(name, this.props.item.total)

      if (
        this._handleActivityInputChanged(name, false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _onKeyPressActivityVatInput (name, ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      this._updateActivityTotal(name, this.props.item.total)

      if (
        this._handleActivityInputChanged(name, false, ev.keyCode === 13, ev)
      ) {
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }

  _handleActivityInputChanged (name, bBlur, bEnter, ev) {
    const { item, isDiscountPhase, showTax } = this.props
    const bEsc = ev.keyCode === 27

    if (!item.title) {
      return false
    }
    if (bBlur) {
      item.bTitleCompleted = item.title
      item.editable = false
    } else {
      if (this.props.isEstimate) {
        if (item.type === 'time-activity' || item.type === 'expense-activity') {
          let editable = false

          if (name === 'title') {
            item.bTitleCompleted = !!item.title
          }

          if (!bEnter) {
            if (name === 'title') {
              editable = this.props.showActivity ? 'total' : 'noHours'
              if (item.type === 'expense-activity') {
                editable = 'sellingPrice'
              }
            } else if (name === 'noHours') {
              editable = 'pricePerHour'
            } else if (name === 'pricePerHour' || name === 'sellingPrice') {
              editable = this.props.showRate
                ? 'total'
                : this.props.showDefaultVat
                ? 'total'
                : 'vat'
            } else if (name === 'vat') {
              editable = 'total'
            } else if (name === 'total') {
              editable = 'description'
              this.data.showExpand = true
            } else if (name === 'description') {
              editable = false
            }

            if (isDiscountPhase) {
              if (name === 'title') {
                editable = 'discountPercentage'
              } else if (name === 'discountPercentage' && showTax) {
                editable = 'vat'
              }
            }
          }

          item.editable = !item.bEdit || !bEsc ? editable : false
          if (item.editable === 'vat') {
            this.data.vatKeyword =
              item.vat || item.vat === 0 ? item.vat.toString() : ''
          }
        }
      } else {
        if (item.type === 'time-activity') {
          let editable = false
          if (name === 'title') {
            item.bTitleCompleted = item.title
          }

          if (!bEnter) {
            if (name === 'title') {
              editable = !item.bUseTotal ? 'noHours' : 'total'
            } else if (name === 'noHours') {
              editable = !item.bUseTotal ? 'pricePerHour' : 'total'
            } else if (name === 'pricePerHour') {
              editable = 'total'
            } else if (name === 'total') {
              editable = false
            }
          }

          item.total = item.total !== '' ? item.total : 0
          item.editable = !item.bEdit || !bEsc ? editable : false
        } else if (item.type === 'expense-activity') {
          let editable = false
          if (name === 'title') {
            item.bTitleCompleted = item.title
          }

          if (!bEnter) {
            if (name === 'title') {
              editable = 'noHours'
            } else if (name === 'noHours') {
              editable = 'pricePerHour'
            } else if (name === 'pricePerHour') {
              editable = 'sellingPrice'
            } else if (name === 'sellingPrice') {
              editable = 'total'
            } else if (name === 'total') {
              editable = false
            }
          }

          item.total = item.total !== '' ? item.total : 0
          item.editable = !item.bEdit || !bEsc ? editable : false
        } else if (item.type === 'text') {
          if (name === 'title') {
            item.bTitleCompleted = item.title
          }

          item.editable = false
        }
      }
    }

    if (item.bTitleCompleted) {
      const updateFields = [name]

      if (name === 'noHours') {
        updateFields.push('total', 'bUseTotal', 'pricePerHour')
      } else if (name === 'pricePerHour') {
        updateFields.push('total', 'bUseTotal', 'noHours')
      } else if (name === 'total') {
        updateFields.push(
          'noHours',
          'pricePerHour',
          'sellingPrice',
          'bUseTotal'
        )
      } else if (name === 'discountPercentage') {
        updateFields.push('total', 'discountPercentage')
      }

      const bUpdateTotal = item.bUpdateTotal
      const bUpdateSpentAmount = item.bUpdateSpentAmount
      const bSaveItem = item.bSaveItem

      delete item.bUpdateTotal
      delete item.bUpdateSpentAmount
      delete item.bSaveItem

      if (bSaveItem) {
        if (!item.id && this.props.onItemCreate) {
          this.props.onItemCreate(item)
          this._onSave()
        } else if (!this.props.isEstimate && bUpdateSpentAmount) {
          this.props.calculateSpentAmount(item, () => {
            updateFields.push('spentAmount', 'percentage')
            this.props.onItemUpdate(item, updateFields)

            // Update project budget and phases
            if (bUpdateTotal) {
              this.props.onUpdateTotal()
            }
          })
        } else {
          this.props.onItemUpdate(item, updateFields)

          // Update project budget and phases
          if (bUpdateTotal) {
            this.props.onUpdateTotal()
          }
        }
      }
    }

    if (!item.editable && !bBlur) {
      if (bEnter) {
        if (this.props.onInsertItemInMiddle) {
          this.props.onInsertItemInMiddle(item.type, ev)
        }
      } else {
        this._updateActivity()
      }
    }

    this.setState({ dataDate: new Date() })
    return true
  }

  _updateActivity () {
    if (this.props.onUpdateEditable) {
      this.props.onUpdateEditable(this.props.item)
      this._onChange()
    }
  }

  _onEditActivity (name) {
    if (!this._isEditEnabled()) return

    const item = this.props.item
    item.editable = name
    item.bEdit = true

    if (name === 'vat') {
      this.data.vatKeyword =
        item[name] || item[name] === 0 ? item[name].toString() : ''
    }

    this._onChange()
  }

  _onEditDescription () {
    const item = this.props.item

    if (this._references.description.current) {
      this._references.description.current.show(item.title)
    }
    this.forceUpdate()
  }

  _onClickExpenseAttachment (ev) {
    ev.preventDefault()

    const item = this.props.item

    if (this._references.refBudgetPurchaseOrder.current) {
      this._references.refBudgetPurchaseOrder.current.show(
        item,
        item.purchaseOrders
      )
    }
    this.forceUpdate()
  }

  _onSelectActivityDate (fromDate, toDate) {
    const item = this.props.item
    item.fromDate = fromDate
    item.toDate = toDate

    if (fromDate && toDate) {
      item.editable = 'noHours'
    }

    this.props.onItemUpdate(item, ['fromDate', 'toDate'])
  }

  _onCloseDate (item) {
    item.editable = false
    this.setState({ dataDate: new Date() })
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.props.item)
    }
  }

  _onSave () {
    if (this.props.onSave) {
      this.props.onSave(this.props.item)
    }
  }

  _onRemoveItem (e) {
    e.preventDefault()

    if (!this.props.item.bUsed && this.props.onRemove) {
      this.props.onRemove()
    }
  }

  _onDeletePhase (_e) {
    if (this.props.onRemove) {
      this.props.onRemove()

      if (this._references.settingsMenu.current) {
        this._references.settingsMenu.current.hide()
      }
    }
  }

  _onCreatePurchaseOrder (itemSupplier) {
    if (this.props.onCreatePurchaseOrder) {
      trackAddPurchaseOrder()
      this.props.onCreatePurchaseOrder(this.props.item, itemSupplier)
    }
  }

  _onBlurActivitySummary (value) {
    const item = this.props.item
    item.summary = value
    item.editable = false

    if (item.id && this.props.onItemUpdate) {
      this.props.onItemUpdate(item, 'summary')
    }
  }

  _onChangeActivitySummary (value) {
    this.props.item.summary = value
  }

  _onKeyPressSummary (name, ev) {
    if (ev.shiftKey && ev.key === 'Enter') {
      ev.preventDefault()
      ev.stopPropagation()
      return false
    }
    return true
  }

  _handleDocumentClick (ev) {
    if (
      this.props.item.showAdd &&
      !Util.targetIsDescendant(ev, ReactDOM.findDOMNode(this))
    ) {
      this._onHideAddAction()
    }
  }

  _onToggleExpand (ev) {
    ev.preventDefault()

    this.data.showExpand = !this.data.showExpand
    this.setState({ dataDate: new Date() })
  }

  _renderEstimateActivityTime () {
    const {
      item,
      phaseFromDate,
      phaseToDate,
      projectStartDate,
      projectEndDate
    } = this.props
    let activityKeyword = this.data.activityKeyword
    let options =
      item.editable === 'title' && !activityKeyword ? this.props.rateCards : []

    if (activityKeyword) {
      activityKeyword = activityKeyword.toLowerCase()
      for (const pOpt of this.props.rateCards) {
        const value = pOpt.value ? pOpt.value.toLowerCase() : ''
        if (value && value.includes(activityKeyword)) {
          options.push(pOpt)
        }
      }
    }

    options = _.sortBy(options, 'value')

    let dateHighlightStart = phaseFromDate
    let dateHighlightEnd = phaseToDate
    if (!dateHighlightStart || !dateHighlightEnd) {
      dateHighlightStart = projectStartDate
      dateHighlightEnd = projectEndDate
    }

    let className = 'itemcontent'
    if (this.props.showRate) {
      className = 'itemcontent showrate'
    } else if (this.props.showTax) {
      className = 'itemcontent showtax'
    } else {
      className = 'itemcontent showactivity'
    }

    return (
      <div className={className}>
        <div className='hovericon'>
          <span className='iconcont'>
            <i className='icon icon-budget-listmenu' />
          </span>
        </div>
        {this._renderItemClose()}
        {this._renderTitleColumn()}
        {this._renderHourColumn()}
        {this._renderRateColumn()}
        {this._renderVatColumn()}
        {this._renderTotalColumn()}
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='project.viewBudget.msgConfirmDelete'
          onClickOk={this._onRemoveItem.bind(this)}
        />
      </div>
    )
  }

  _renderHourColumn () {
    const { item } = this.props

    const bHidePriceEdit = !!item.bUseTotal
    const selectedHourlabel = item.type !== 'expense-activity'
      ? 'project.viewBudget.selectedHours'
      : 'project.viewBudget.selectedUnits'

    return (
      <div className='itemcol itemcolhour'>
        {item.editable === 'noHours' ? (
          <div className='label'>
            <InputNumber
              type='text'
              name='noHours'
              maxLength={120}
              label={selectedHourlabel}
              required
              className='inlinesmall-input'
              validations={['required']}
              value={item.noHours}
              autoFocus
              onChange={this._onChangeActivityInput.bind(this, 'noHours')}
              onBlur={this._onBlurActivityInput.bind(this, 'noHours')}
              onKeyDown={this._onKeyPressActivityInput.bind(this, 'noHours')}
            />
          </div>
        ) : bHidePriceEdit ? (
          <div
            className='label alt'
            onClick={this._onEditActivity.bind(this, 'noHours')}
          >
            <IntlMessage ident='project.viewBudget.totalPriceNull' />
          </div>
        ) : (
          <div
            className='label'
            onClick={this._onEditActivity.bind(this, 'noHours')}
          >
            <span className='value'>
              {app.projectSetting.showProMemoria && item.noHours === 0 ? <IntlMessage ident='project.viewBudget.proMemoria' /> : item.noHours}
            </span>
          </div>
        )}
      </div>
    )
  }

  _renderRateColumn () {
    const { item } = this.props

    const bHidePriceEdit = !!item.bUseTotal
    const selectedPricelabel = item.type !== 'expense-activity'
      ? 'project.viewBudget.pricePerHours'
      : 'project.viewBudget.pricePerUnits'

    return (
      <div className='itemcol itemcolrate'>
        {item.editable === 'pricePerHour' ? (
          <div className='label'>
            <InputPrice
              type='text'
              name='pricePerHour'
              maxLength={120}
              label={selectedPricelabel}
              required
              className='inlinesmall-input'
              validations={['required']}
              value={item.pricePerHour}
              autoFocus
              onChange={this._onChangeActivityInput.bind(
                this,
                'pricePerHour'
              )}
              onBlur={this._onBlurActivityInput.bind(this, 'pricePerHour')}
              onKeyDown={this._onKeyPressActivityInput.bind(
                this,
                'pricePerHour'
              )}
            />
          </div>
        ) : bHidePriceEdit ? (
          <div
            className='label alt'
            onClick={this._onEditActivity.bind(this, 'pricePerHour')}
          >
            <IntlMessage ident='project.viewBudget.totalPriceNull' />
          </div>
        ) : (
          <div
            className='label'
            onClick={this._onEditActivity.bind(this, 'pricePerHour')}
          >
            <PriceText value={item.pricePerHour} />
          </div>
        )}
      </div>
    )
  }

  _renderDiscountColumns () {
    const { showTax } = this.props
    const classname = classnames('itemcontent', {
      showTax
    })

    return (
      <div className={classname}>
        <div className='hovericon'>
          <span className='iconcont'>
            <i className='icon icon-budget-listmenu' />
          </span>
        </div>
        {this._renderItemClose()}
        {this._renderTitleColumn()}
        {this._renderDiscountColumn()}
        {this._renderVatColumn()}
        {this._renderTotalColumn()}
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='project.viewBudget.msgConfirmDelete'
          onClickOk={this._onRemoveItem.bind(this)}
        />
      </div>
    )
  }

  _renderVatColumn () {
    const {
      item,
      taxRateVatOptions,
      showVatAutocomplete,
      showDefaultVat
    } = this.props

    if (showDefaultVat) {
      return (
        <div className='itemcol itemcolvat'>
          <div className='label'>
            <div className='value'>{item.vat} %</div>
          </div>
        </div>
      )
    }

    const vatOptions = []
    taxRateVatOptions.forEach(vatOpt => {
      const vatType = vatOpt.isService
        ? 'Service'
        : vatOpt.isProduct
        ? 'Product'
        : ''
      let bVatMatch = false

      if (this.data.vatKeyword !== '0' && this.data.vatKeyword) {
        const vatValue =
          vatOpt.value !== undefined ? vatOpt.value.toString() : ''
        if (vatValue && vatValue.includes(this.data.vatKeyword)) {
          bVatMatch = true
        }
      } else {
        bVatMatch = true
      }

      if (bVatMatch) {
        if (item.labelType === '') {
          vatOptions.push(vatOpt)
        } else if (vatType === item.labelType) {
          vatOptions.push(vatOpt)
        }
      }
    })

    return (
      <div className='itemcol itemcolvat'>
        {item.editable === 'vat' ? (
          <div className='label'>
            {showVatAutocomplete ? (
              <FormVatAutoComplete
                name='vat'
                autoFocus
                value={item.vat}
                displayValue={this.data.vatKeyword}
                options={vatOptions}
                onChange={this._onChangeActivityVatKeyword.bind(this, item)}
                onSelect={this._onSelectActivityVat.bind(this)}
                showAdd={false}
                showVatAdd={this.data.vatKeyword && this.data.showVatAdd}
                showSelection
                hasAutoSelect={false}
                keywordLength={0}
                bShowButton
                onSaveVat={this._onSaveVat.bind(this)}
                onBlur={this._onBlurVat.bind(this)}
                onKeyDown={this._onKeyPressVat.bind(this)}
              />
            ) : (
              <ReactSelect
                name='vat'
                className='select-alt select-itemvat vat'
                value={
                  _.find(
                    this.data.vatLevels,
                    obj => obj.value === item.vat
                  ) || null
                }
                options={this.data.vatLevels}
                classNamePrefix='typeitem'
                clearable={false}
                openOnFocus
                onChange={this._onChangeActivityVat.bind(this, 'vat')}
                onBlur={this._onBlurActivityInput.bind(this, 'vat')}
                onInputKeyDown={this._onKeyPressActivityVatInput.bind(
                  this,
                  'vat'
                )}
              />
            )}
          </div>
        ) : (
          <div
            className='label'
            onClick={this._onEditActivity.bind(this, 'vat')}
          >
            <div className='value'>{item.vat} %</div>
          </div>
        )}
      </div>
    )
  }

  _renderItemClose () {
    return (
      <span
        className='itemclose'
        onClick={this._onRemoveActivityTime.bind(this)}
      >
        <i className='icon icon-phase-close' />
      </span>
    )
  }

  _renderTitleColumn () {
    const { item } = this.props

    return (
      <div className='itemcol itemcoltitle'>
        {item.editable === 'title' ? (
          <div className='label'>
            <FormRateCardAutoComplete
              label='project.viewBudget.estimateTimeActivity'
              name='title'
              ref={this._references.inputTimeTitle}
              autoFocus
              validations={['required']}
              value={item.title}
              displayValue={item.title}
              onChange={this._handleSearchActivity.bind(this)}
              onSelect={this._handleActivityTitleSelect.bind(this)}
              onBlur={this._handleActivityTitleBlur.bind(this)}
              onKeyDown={this._onKeyPressActivityTitleInput.bind(this)}
              hideAdd
              hasAutoSelect={false}
            />
          </div>
        ) : (
          <div
            className='label'
            onClick={this._onEditActivity.bind(this, 'title')}
          >
            <span className='value'>{item.title}</span>
          </div>
        )}
      </div>
    )
  }

  _renderTotalColumn () {
    const {
      item,
      phaseStatus
    } = this.props

    return (
      <div className='itemcol itemcolspent'>
        {this._renderProgress(item.percentage, phaseStatus)}
        <div
          className='label'
          onClick={this._onEditActivity.bind(this, 'total')}
        >
          <PriceText value={item.total} />
        </div>
      </div>
    )
  }

  _renderDiscountColumn () {
    const { item } = this.props

    return (
      <div className='itemcol itemcoldiscount'>
        {item.editable === 'discountPercentage' ? (
          <div className='label'>
            <InputNumber
              type='text'
              name='discountPercentage'
              maxLength={4}
              required
              className='inlinesmall-input'
              validations={['required']}
              value={item.discountPercentage}
              autoFocus
              onChange={this._onChangeActivityInput.bind(this, 'discountPercentage')}
              onBlur={this._onBlurActivityInput.bind(this, 'discountPercentage')}
              onKeyDown={this._onKeyPressActivityInput.bind(this, 'discountPercentage')}
            />
          </div>
        ) : (
          <div
            className='label'
            onClick={this._onEditActivity.bind(this, 'discountPercentage')}
          >
            <span className='value'>{item.discountPercentage}%</span>
          </div>
        )}
      </div>
    )
  }

  _renderEstimateActivityText () {
    const { item } = this.props
    return (
      <div className='itemcontent'>
        <div className='hovericon'>
          <span className='iconcont'>
            <i className='icon icon-budget-listmenu' />
          </span>
        </div>
        <span className='itemclose' onClick={this._onRemoveItem.bind(this)}>
          <i className='icon icon-phase-close' />
        </span>
        <div
          className='itemcol itemcoltitle itemcoltext'
          onClick={
            item.editable === 'title'
              ? null
              : this._onEditActivity.bind(this, 'title')
          }
        >
          {item.editable === 'title' ? (
            <div className='label'>
              <WysiwygEditor
                placeholder='project.viewBudget.enterDescription'
                value={item.title}
                onBlur={this._onBlurActivityText.bind(this)}
                onChange={this._onChangeActivityText.bind(this)}
                onKeyDown={this._onKeyPressSummary.bind(this, 'title')}
                autoFocus
              />
            </div>
          ) : (
            <div className='label'>
              <div dangerouslySetInnerHTML={{ __html: item.title }} />
            </div>
          )}
        </div>
      </div>
    )
  }

  _renderActivityText () {
    const { dragItem, item, isEstimate } = this.props
    const _className = classnames('phaseitem', 'phaseitem_text', {
      phaseitem_isdragging:
        dragItem &&
        dragItem.dragItemType === 'item' &&
        dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem
    })
    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          {this._isEditEnabled() && (
            <span
              className='phaseitem-close'
              onClick={this._onRemoveItem.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          {!isEstimate && this._isEditEnabled() && (
            <span className='addsplitter' />
          )}
          <div className='cont'>
            <div className='col coltitle coltitle_text typo wysiwygtypo'>
              {item.editable === 'title' ? (
                <WysiwygEditor
                  placeholder='project.viewBudget.enterDescription'
                  value={item.title}
                  onBlur={this._onBlurActivityText.bind(this)}
                  onChange={this._onChangeActivityText.bind(this)}
                  onKeyDown={this._onKeyPressSummary.bind(this, 'title')}
                  autoFocus
                />
              ) : (
                <div
                  className='label'
                  onClick={this._onEditActivity.bind(this, 'title')}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.title }} />
                </div>
              )}
            </div>
          </div>
          {this._isEditEnabled() &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
        </div>
      </div>
    )
  }

  _renderActivityTime () {
    const { dragItem, item, phaseStatus, hideDateRange } = this.props
    const _className = classnames('phaseitem', {
      phaseitem_isdragging:
        dragItem &&
        dragItem.dragItemType === 'item' &&
        dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem
    })

    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource
    const bHidePriceEdit = !!item.bUseTotal

    let activityKeyword = this.data.activityKeyword
    let options =
      item.editable === 'title' && !activityKeyword ? this.props.rateCards : []

    if (activityKeyword) {
      activityKeyword = activityKeyword.toLowerCase()
      for (const pOpt of this.props.rateCards) {
        const value = pOpt.value ? pOpt.value.toLowerCase() : ''
        if (value && value.includes(activityKeyword)) {
          options.push(pOpt)
        }
      }
    }

    options = _.sortBy(options, 'value')

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          {this._isEditEnabled() && !this.props.item.bUsed && (
            <span
              className='phaseitem-close'
              onClick={this._onRemoveActivityTime.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          <div className='cont'>
            <div className='col coltitle'>
              {item.editable === 'title' ? (
                <div className='info'>
                  <FormRateCardAutoComplete
                    label='project.viewBudget.timeActivity'
                    name='title'
                    autoFocus
                    ref={this._references.inputTimeTitle}
                    validations={['required']}
                    value={item.title}
                    displayValue={item.title}
                    options={options}
                    onChange={this._handleSearchActivity.bind(this)}
                    onSelect={this._handleActivityTitleSelect.bind(this)}
                    onBlur={this._handleActivityTitleBlur.bind(this)}
                    onKeyDown={this._onKeyPressActivityTitleInput.bind(this)}
                    hideAdd
                    showOptionIcon
                    showSelection={!!(options && options.length > 0)}
                    hasAutoSelect={false}
                  />
                </div>
              ) : (
                <div
                  className='info'
                  onClick={this._onEditActivity.bind(this, 'title')}
                >
                  {item.title}
                </div>
              )}
              <div className='subinfo'>
                <span className='iconcont'>
                  <i className='icon icon-budget-time' />
                </span>
                {!hideDateRange &&
                  (item.editable === 'daterange' && item.title !== '' ? (
                    <span className='label date'>
                      <DateRangePicker
                        ref={this._references.daterange}
                        startDate={item.fromDate}
                        active
                        endDate={item.toDate}
                        onSelect={this._onSelectActivityDate.bind(this)}
                        onClose={this._onCloseDate.bind(this, item)}
                      />
                    </span>
                  ) : (
                    <span
                      className='label date'
                      onClick={this._onEditActivity.bind(this, 'daterange')}
                    >
                      <span className='iconcont'>
                        <i className='icon icon-phase-calendar' />
                      </span>
                      {this._renderItemDate(item)}
                    </span>
                  ))}
                {!hideDateRange && <span className='label splitter' />}
                {bHidePriceEdit ? (
                  <span
                    className='label'
                    onClick={this._onClickTotalPrice.bind(this, item)}
                  >
                    <IntlMessage ident='project.viewBudget.totalPriceInfo' />
                  </span>
                ) : (
                  ''
                )}
                {this._renderTimeActivityNoHours(bHidePriceEdit, item)}
                {bHidePriceEdit ? '' : <span className='label splitter' />}
                {this._renderTimeActivityPricePerHour(bHidePriceEdit, item)}
              </div>
            </div>
            {item.bTitleCompleted ? (
              <div className='col colprogress'>
                <div className='action'>
                  {this._isEditEnabled() &&
                    (item.description ? (
                      <span
                        className='desc active'
                        ref={this._references.triggerDescription}
                      >
                        <i
                          className='icon icon-phase-description-hover hover'
                          onClick={this._onEditDescription.bind(this)}
                        />
                      </span>
                    ) : (
                      <span
                        className='desc canhover'
                        ref={this._references.triggerDescription}
                      >
                        <i
                          className='icon icon-phase-description'
                          onClick={this._onEditDescription.bind(this)}
                        />
                        <i
                          className='icon icon-phase-description-hover hover'
                          onClick={this._onEditDescription.bind(this)}
                        />
                      </span>
                    ))}
                  <span className='setting'>
                    <i
                      className='icon icon-phase-setting'
                      ref={this._references.triggerSetting}
                      onClick={this._onClickSetting.bind(this)}
                    />
                  </span>
                </div>
                <PopupDescription
                  ref={this._references.description}
                  description={item.description}
                  container={this}
                  target={this._references.triggerDescription.current}
                  onChange={this._onChangeActivityDesc.bind(
                    this,
                    'description'
                  )}
                />
              </div>
            ) : (
              <div className='col colprogress'>
                {this._renderGroupActions(item)}
              </div>
            )}
            <div className='col colbudget'>
              {item.bTitleCompleted && item.editable === 'total' ? (
                <span className='budget'>
                  <InputPrice
                    type='text'
                    name='total'
                    maxLength={120}
                    label='project.viewBudget.priceDefault'
                    required
                    className='inlinebig-input'
                    validations={['required']}
                    value={item.total || ''}
                    autoFocus
                    onChange={this._onChangeActivityInput.bind(this, 'total')}
                    onBlur={this._onBlurActivityInput.bind(this, 'total')}
                    onKeyDown={this._onKeyPressActivityInput.bind(
                      this,
                      'total'
                    )}
                  />
                </span>
              ) : (
                <span
                  className='budget'
                  onClick={this._onEditActivity.bind(this, 'total')}
                >
                  <span className='bdgtprefix'>{currency.symbol()}</span>
                  {currency.format(item.total)}
                </span>
              )}
            </div>
            <div
              className={`col colspent${
                item.spentAmount > 1000000 ? ' coltextsmall' : ''
              }`}
            >
              {this._renderProgress(item.percentage, phaseStatus)}
              {item.editable === 'spentAmount' ? (
                <span className='spent'>
                  <InputPrice
                    type='text'
                    name='spentAmount'
                    maxLength={120}
                    label='project.viewBudget.priceDefault'
                    required
                    className='inlinebig-input'
                    validations={['required']}
                    value={item.spentAmount}
                    autoFocus
                    onChange={this._onChangeActivityInput.bind(
                      this,
                      'spentAmount'
                    )}
                    onBlur={this._onBlurActivityInput.bind(this, 'spentAmount')}
                    onKeyDown={this._onKeyPressActivityInput.bind(
                      this,
                      'spentAmount'
                    )}
                  />
                </span>
              ) : (
                <span className='spent'>
                  <span className='bdgtprefix'>{currency.symbol()}</span>
                  {currency.format(item.spentAmount)}
                </span>
              )}
            </div>
          </div>
          {this._isEditEnabled() &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
          <MenuDropdown
            ref={this._references.settingsMenu}
            items={this.data.menuItems}
            target={this._references.triggerSetting.current}
            onClick={this._onDeletePhase.bind(this)}
          />
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='project.viewBudget.msgConfirmDelete'
          onClickOk={this._onRemoveItem.bind(this)}
        />
      </div>
    )
  }

  _renderPageBreaker () {
    const { dragItem, item, disableDrag } = this.props
    const _className = classnames('phaseitem', 'phaseitem_pagebreaker', {
      phaseitem_isdragging:
        dragItem &&
        dragItem.dragItemType === 'item' &&
        dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem
    })
    const connectDragSource =
      this.props.connectDragSource && !disableDrag
        ? this.props.connectDragSource
        : this._connectDragSource

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          {this._isEditEnabled() && (
            <span
              className='phaseitem-close'
              onClick={this._onRemoveItem.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          <div className='cont'>
            <div className='col colbreaker'>
              <IntlMessage ident='project.viewBudget.pageBreaker' />
            </div>
          </div>
          {this._isEditEnabled() &&
            !disableDrag &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
        </div>
        {!item.showAdd && this._isEditEnabled() && (
          <div className='addsplitter'>
            <div
              className='hovericon addaction'
              onClick={this._onShowAddAction.bind(this, item)}
            >
              <span className='iconcont'>
                <i className='icon icon-common-itemadd' />
              </span>
            </div>
            <div className='line' />
          </div>
        )}
        {item.showAdd && this._renderActivityAction()}
      </div>
    )
  }

  _renderItemDate (item) {
    // Intially If fromDate and toDate are null return label
    if (item.fromDate === null && item.toDate === null) {
      return ''
      // If toDate is null or 0 return fromDate alone
    } else if (
      item.toDate === 0 ||
      (item.toDate === null && item.fromDate !== null)
    ) {
      return `${DateUtil.getDisplayDate(item.fromDate)}`
      // else return fromDate and ToDate
    } else {
      return `${DateUtil.getDisplayDate(
        item.fromDate
      )} - ${DateUtil.getDisplayDate(item.toDate)} `
    }
  }

  _onShowAddAction (item, ev) {
    ev.preventDefault()

    document.addEventListener('click', this._documentListener)

    this.props.item.showAdd = true
    this.setState({ dataDate: new Date() })
  }

  _onClickTotalPrice (item) {
    item.bUseTotal = false
    item.bUpdateSpentAmount = true
    item.bUpdateTotal = true
    item.bSaveItem = true

    this._onEditActivity('noHours')
  }

  _renderTimeActivityNoHours (bHidePriceEdit, item) {
    if (bHidePriceEdit) {
      return ''
    }

    if (item.editable === 'noHours') {
      return (
        <span className='label'>
          <InputNumber
            type='text'
            name='noHours'
            maxLength={120}
            label='project.viewBudget.selectedHours'
            required
            className='inlinesmall-input'
            validations={['required']}
            value={item.noHours}
            autoFocus
            onChange={this._onChangeActivityInput.bind(this, 'noHours')}
            onBlur={this._onBlurActivityInput.bind(this, 'noHours')}
            onKeyDown={this._onKeyPressActivityInput.bind(this, 'noHours')}
          />
          <IntlMessage ident='project.viewBudget.labelHours' />
        </span>
      )
    }

    return (
      <span
        className='label'
        onClick={this._onEditActivity.bind(this, 'noHours')}
      >
        {item.noHours ? currency.format(item.noHours) : currency.format(0)}
        &nbsp;
        <IntlMessage ident='project.viewBudget.labelHours' />
      </span>
    )
  }

  _renderTimeActivityPricePerHour (bHidePriceEdit, item) {
    if (bHidePriceEdit) {
      return ''
    }

    if (item.editable === 'pricePerHour') {
      return (
        <span className='label'>
          <InputPrice
            type='text'
            name='pricePerHour'
            maxLength={120}
            label='project.viewBudget.pricePerHours'
            required
            className='inlinesmall-input'
            validations={['required']}
            value={item.pricePerHour}
            autoFocus
            onChange={this._onChangeActivityInput.bind(this, 'pricePerHour')}
            onBlur={this._onBlurActivityInput.bind(this, 'pricePerHour')}
            onKeyDown={this._onKeyPressActivityInput.bind(this, 'pricePerHour')}
          />
          <IntlMessage ident='project.viewBudget.labelPerHour' />
        </span>
      )
    }

    return (
      <span
        className='label'
        onClick={this._onEditActivity.bind(this, 'pricePerHour')}
      >
        {currency.format(item.pricePerHour)}
        &nbsp;
        <IntlMessage ident='project.viewBudget.labelPerHour' />
      </span>
    )
  }

  _renderActivityExpense () {
    const { dragItem, item, phaseStatus } = this.props
    const _className = classnames('phaseitem', {
      phaseitem_isdragging:
        dragItem &&
        dragItem.dragItemType === 'item' &&
        dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem
    })
    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource

    return (
      <div className={_className}>
        <div className='phaseitem-inner'>
          {this._isEditEnabled() && !this.props.item.bUsed && (
            <span
              className='phaseitem-close'
              onClick={this._onRemoveItemExpense.bind(this)}
            >
              <i className='icon icon-phase-close' />
            </span>
          )}
          <div className='cont'>
            <div className='col coltitle'>
              {item.editable === 'title' ? (
                <div className='info'>
                  <Input
                    type='text'
                    name='title'
                    maxLength={120}
                    label='project.viewBudget.newExpense'
                    required
                    className='inline-input'
                    validations={['required']}
                    value={item.title}
                    autoFocus
                    onChange={this._onChangeActivityInput.bind(this, 'title')}
                    onBlur={this._onBlurActivityInput.bind(this, 'title')}
                    onKeyDown={this._onKeyPressActivityInput.bind(
                      this,
                      'title'
                    )}
                  />
                </div>
              ) : (
                <div
                  className='info'
                  onClick={this._onEditActivity.bind(this, 'title')}
                >
                  {item.title}
                </div>
              )}
              {item.editable === 'sellingPrice' ? (
                <div className='subinfo'>
                  <span className='iconcont'>
                    <i className='icon icon-budget-expense' />
                  </span>
                  <span className='label'>
                    <IntlMessage ident='project.viewBudget.labelSellingPrice' />
                  </span>
                  <span className='value'>
                    <InputPrice
                      type='text'
                      name='sellingPrice'
                      maxLength={120}
                      label='project.viewBudget.newExpenseLabel'
                      required
                      className='inlinemedium-input'
                      validations={['required']}
                      value={item.sellingPrice}
                      autoFocus
                      onChange={this._onChangeActivityInput.bind(
                        this,
                        'sellingPrice'
                      )}
                      onBlur={this._onBlurActivityInput.bind(
                        this,
                        'sellingPrice'
                      )}
                      onKeyDown={this._onKeyPressActivityInput.bind(
                        this,
                        'sellingPrice'
                      )}
                    />
                  </span>
                </div>
              ) : (
                <div
                  className='subinfo'
                  onClick={this._onEditActivity.bind(this, 'sellingPrice')}
                >
                  <span className='iconcont'>
                    <i className='icon icon-budget-expense' />
                  </span>
                  <span className='label'>
                    <IntlMessage ident='project.viewBudget.labelSellingPrice' />
                  </span>
                  <span className='value'>
                    {this._renderPrice(item.sellingPrice)}
                  </span>
                </div>
              )}
            </div>
            {item.bTitleCompleted ? (
              <div className='col colprogress'>
                <div className='action'>
                  {this._isEditEnabled() &&
                    (item.description ? (
                      <span
                        className='desc active'
                        ref={this._references.triggerDescription}
                      >
                        <i
                          className='icon icon-phase-description-hover hover'
                          onClick={this._onEditDescription.bind(this)}
                        />
                      </span>
                    ) : (
                      <span
                        className='desc canhover'
                        ref={this._references.triggerDescription}
                      >
                        <i
                          className='icon icon-phase-description'
                          onClick={this._onEditDescription.bind(this)}
                        />
                        <i
                          className='icon icon-phase-description-hover hover'
                          onClick={this._onEditDescription.bind(this)}
                        />
                      </span>
                    ))}
                  {this._isEditEnabled() &&
                    (item &&
                    item.purchaseOrders &&
                    item.purchaseOrders.length > 0 ? (
                      <span
                        className='attachment active'
                        ref={this._references.triggerPurchaseOrder}
                        onClick={this._onClickExpenseAttachment.bind(this)}
                      >
                        <i className='icon icon-popup-purchaseorder-hover hover' />
                      </span>
                    ) : (
                      <span
                        className='attachment canhover'
                        ref={this._references.triggerPurchaseOrder}
                        onClick={this._onClickExpenseAttachment.bind(this)}
                      >
                        <i className='icon icon-popup-purchaseorder' />
                        <i className='icon icon-popup-purchaseorder-hover hover' />
                      </span>
                    ))}
                  <span className='setting'>
                    <i
                      className='icon icon-phase-setting'
                      ref={this._references.triggerSetting}
                      onClick={this._onClickSetting.bind(this)}
                    />
                  </span>
                </div>
                <PopupDescription
                  ref={this._references.description}
                  description={item.description}
                  container={this}
                  target={this._references.triggerDescription.current}
                  onChange={this._onChangeActivityDesc.bind(
                    this,
                    'description'
                  )}
                />
              </div>
            ) : (
              <div className='col colprogress'>
                {this._renderGroupActions(item)}
              </div>
            )}
            {item.bTitleCompleted && (
              <div className='col colbudget'>
                {item.bTitleCompleted && item.editable === 'total' ? (
                  <span className='budget'>
                    <InputPrice
                      type='text'
                      name='total'
                      maxLength={120}
                      label='project.viewBudget.expensePriceDefault'
                      required
                      className='inlinebig-input'
                      validations={['required']}
                      value={item.total || ''}
                      autoFocus
                      onChange={this._onChangeActivityInput.bind(this, 'total')}
                      onBlur={this._onBlurActivityInput.bind(this, 'total')}
                      onKeyDown={this._onKeyPressActivityInput.bind(
                        this,
                        'total'
                      )}
                    />
                  </span>
                ) : (
                  <span
                    className='budget'
                    onClick={this._onEditActivity.bind(this, 'total')}
                  >
                    <span className='bdgtprefix'>{currency.symbol()}</span>
                    {currency.format(item.total)}
                  </span>
                )}
              </div>
            )}
            <div
              className={`col colspent${
                item.spentAmount > 1000000 ? ' coltextsmall' : ''
              }${item.percentage > 100 ? ' over' : ''}`}
            >
              {this._renderProgress(item.percentage, phaseStatus)}
              <span className='spent'>
                <span className='bdgtprefix'>{currency.symbol()}</span>
                {currency.format(item.spentAmount)}
              </span>
            </div>
          </div>
          {this._isEditEnabled() &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu' />
                </span>
              </div>
            )}
          <MenuDropdown
            ref={this._references.settingsMenu}
            items={this.data.menuItems}
            target={this._references.triggerSetting.current}
            onClick={this._onDeletePhase.bind(this)}
          />
          <PopupBudgetPurchaseorder
            ref={this._references.refBudgetPurchaseOrder}
            container={this}
            target={this._references.triggerPurchaseOrder.current}
            onSearchSupplier={this.props.onSearchSupplier}
            onCreateItemSupplier={this.props.onCreateItemSupplier}
            onDeleteItemSupplier={this.props.onDeleteItemSupplier}
            onClickAdd={this._onCreatePurchaseOrder.bind(this)}
            onViewPurchaseOrder={this.props.onViewPurchaseOrder}
            onContactAdd={this.props.onCreateContact}
          />
          <ConfirmDelete
            ref={this._references.confirmDelete}
            title='project.viewBudget.msgConfirmDelete'
            onClickOk={this._onRemoveItem.bind(this)}
          />
        </div>
      </div>
    )
  }

  _onRemoveEstimateActivityTime (_e) {
    if (this.props.item && this.props.item.title) {
      if (this._references.confirmDelete.current) {
        this._references.confirmDelete.current.show()
      }
    } else {
      this._onRemoveItem(_e)
    }
  }

  _onRemoveActivityTime (e) {
    if (this.props.item && this.props.item.description) {
      if (this._references.confirmDelete.current) {
        this._references.confirmDelete.current.show()
      }
    } else {
      this._onRemoveItem(e)
    }
  }

  _isFilterByExpense () {
    return this.props.filterType === 'expense'
  }

  _isFilterByTime () {
    return this.props.filterType === 'time'
  }

  _onRemoveItemExpense (e) {
    if (
      (this.props.item && this.props.item.description) ||
      (this.props.item.purchaseOrders &&
        this.props.item.purchaseOrders.length > 0)
    ) {
      if (this._references.confirmDelete.current) {
        this._references.confirmDelete.current.show()
      }
    } else {
      this._onRemoveItem(e)
    }
  }

  _renderActivitySubtotal () {
    const { dragItem, item } = this.props
    const _className = classnames('phaseitem', 'subtotal', {
      phaseitem_isdragging:
        dragItem &&
        dragItem.dragItemType === 'item' &&
        dragItem.dragId === item.dragId,
      phaseitem_isdraftdrag: item.isEmptyDragItem
    })
    const connectDragSource = this.props.connectDragSource
      ? this.props.connectDragSource
      : this._connectDragSource
    const subtotal = item.total ? item.total : 0

    return (
      <div className={_className}>
        {this._isEditEnabled() && (
          <span
            className='phaseitem-close'
            onClick={this._onRemoveItem.bind(this)}
          >
            <i className='icon icon-phase-close' />
          </span>
        )}
        <div className='col colsubtotal'>
          <span className='label'>
            <IntlMessage ident='project.viewBudget.labelSubTotal' />
          </span>
          <span className='value'>
            <span className='bdgtprefix'>{currency.symbol()}</span>
            {currency.format(subtotal)}
          </span>
        </div>
        {this._isEditEnabled() &&
          connectDragSource(
            <div className='hovericon'>
              <span className='iconcont'>
                <i className='icon icon-budget-listmenu' />
              </span>
            </div>
          )}
      </div>
    )
  }

  _renderGroupActions () {
    if (!this._isEditEnabled()) return ''

    const { item } = this.props
    const type = item.type

    const timeClass = type === 'time-activity' ? 'linkitem active' : 'linkitem'
    const expenseClass =
      type === 'expense-activity' ? 'linkitem active' : 'linkitem'
    const textClass = type === 'text' ? 'linkitem active' : 'linkitem'
    const subtotalClass = type === 'subtotal' ? 'linkitem active' : 'linkitem'

    return (
      <div className='linkgrp'>
        <div
          className={timeClass}
          onClick={this._onChangingType.bind(this, 'time-activity')}
        >
          <span className='iconcont'>
            <i className='icon icon-phase-tab-time' />
          </span>
          <span className='title'>
            <IntlMessage ident='project.viewBudget.timeActivity' />
          </span>
        </div>
        <div
          className={expenseClass}
          onClick={this._onChangingType.bind(this, 'expense-activity')}
        >
          <span className='iconcont'>
            <i className='icon icon-phase-tab-expense' />
          </span>
          <span className='title'>
            <IntlMessage ident='project.viewBudget.expense' />
          </span>
        </div>
        <div
          className={textClass}
          onClick={this._onChangingType.bind(this, 'text')}
        >
          <span className='iconcont'>
            <i className='icon icon-phase-tab-text' />
          </span>
          <span className='title'>
            <IntlMessage ident='project.viewBudget.text' />
          </span>
        </div>
        <div
          className={subtotalClass}
          onClick={this._onChangingType.bind(this, 'subtotal')}
        >
          <span className='iconcont'>
            <i className='icon icon-phase-tab-text' />
          </span>
          <span className='title'>
            <IntlMessage ident='project.viewBudget.subTotal' />
          </span>
        </div>
      </div>
    )
  }

  _renderPrice (price) {
    return (
      <span>
        {price ? (
          currency.formatSymbol(price)
        ) : (
          <IntlMessage ident='project.viewBudget.purchasePriceTotalPrice' />
        )}
      </span>
    )
  }

  _connectDragSource (node) {
    return node
  }

  _isEditEnabled () {
    return !this.props.disabledEdit
  }

  _renderProgress (percentage, phaseStatus) {
    if (percentage <= 0) {
      return ''
    }

    let statClass = `progress ${phaseStatus ? phaseStatus.toLowerCase() : ''}`
    let displayValue = percentage
    if (displayValue > 100) {
      displayValue = displayValue < 200 ? displayValue - 100 : 100
    }

    if (percentage > 100) {
      statClass = statClass + ' over'
    }

    return (
      <div className={statClass}>
        <span className='stats-text'>{percentage}%</span>
        <div className='stats'>
          <div className='statpercent' style={{ width: `${displayValue}%` }} />
        </div>
      </div>
    )
  }
}

export default EstimateBudgetItemBase
